import { GetDataRecipeDetailMeta, GetDataRecipeDetailPayload } from 'types/store/GetDataRecipeDetail';
import { createAsyncReducer } from 'utils/Redux';

import { getDataRecipeDetailActions } from '../actions';

export default createAsyncReducer<GetDataRecipeDetailMeta, GetDataRecipeDetailPayload>(getDataRecipeDetailActions);
